import { Alert, Button } from '@mui/material';
import { useGetPickemLeaderboardCSVMutation } from '@/api/leaderboard/getPickemLeaderboardCSV.ts';
import Iconify from '@/components/iconify/index.tsx';

export const ExportCsvButton = ({ pickemId }: { pickemId: number }) => {
  const { mutateAsync, isPending, error } =
    useGetPickemLeaderboardCSVMutation(pickemId);

  const handleDownloadCsv = async () => {
    const response = await mutateAsync();

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    const now = new Date();
    const dateTime = now.toISOString().slice(0, 16).replace('T', ' ');
    link.setAttribute(
      'download',
      `leaderboard-pickem-${pickemId} ${dateTime}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Button
        variant='contained'
        startIcon={<Iconify icon='eva:download-outline' />}
        onClick={() => handleDownloadCsv()}
        disabled={isPending}
      >
        Export CSV
      </Button>
      {error && (
        <Alert severity='warning'>
          Error during CSV download: {error?.message}
        </Alert>
      )}
    </>
  );
};
